var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMobileInteract = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 51,
    viewBox: "0 0 36 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.682 22.16a3.34 3.34 0 1 0-6.682 0v11.135C1 42.521 8.48 50 17.704 50c9.226 0 16.705-7.48 16.705-16.705v-8.909a3.34 3.34 0 1 0-6.682 0V22.16a3.34 3.34 0 1 0-6.681 0v-2.227a3.34 3.34 0 1 0-6.682 0V4.34a3.34 3.34 0 1 0-6.682 0v25.613-7.795Z",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgMobileInteract as ReactComponent };